import { samepleUserActivityData } from './../../components/usermanagement/users/activityLog/helper'
import { useEffect } from 'react'
import { ActivityLogItem } from '../../components/usermanagement/users/activityLog/TimeLineItem'
import { useLazyGetUserLogActivityQuery } from '../../api/app/UserManagementApiService'
// import { samepleUserActivityData } from '../../components/usermanagement/users/activityLog/helper'
import {
  UserActivityEvent,
  UserActivityLogResponse,
} from '../../interface/response/UserRolesResponse'

interface UseUserActivityHooksReturn {
  userActivityData: ActivityLogItem[]
  isloadingActivityData: boolean
}

const mapEventToActivityLogItem = (
  event: UserActivityEvent,
): ActivityLogItem => ({
  eventKey: event.eventKey,
  actionType: event.actionType,
  userName: event.userName,
  actorRole: event.actorRole,
  applicationName: event.applicationName,
  keys: event.keys,
  timeStampKeys: event.timeStampKeys,
  previousInfo: event.previousInfo,
  newInfo: event.newInfo,
  heading: event.heading,
  eventTimeStamp: event.eventTimeStamp,
  roles: event.roles,
  temporaryRoles: event.temporaryRoles,
})

const useUserActivityHooks = (
  selectedUserId?: number,
  userCode?: string,
): UseUserActivityHooksReturn => {
  const [getUserLogActivity, { data, isFetching }] =
    useLazyGetUserLogActivityQuery()

  useEffect(() => {
    const identifier =
      userCode ?? (selectedUserId ? String(selectedUserId) : undefined)
    if (identifier) {
      getUserLogActivity(identifier)
    }
  }, [selectedUserId, userCode, getUserLogActivity])

  const response = data?.data as UserActivityLogResponse | undefined

  const userActivityData: ActivityLogItem[] =
    response?.events?.map(mapEventToActivityLogItem) ?? []

  return { userActivityData, isloadingActivityData: isFetching }
}

export default useUserActivityHooks
